import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import '@/style/style.css'
import '@/assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import common from '@/assets/js/common.js'
import VueLazyload from 'vue-lazyload'
import api from  "@/api/api"
import noImg from '@/assets/img/common/noimg.png'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueCropper from 'vue-cropper' 

Vue.prototype.common = common;//公共方法js
Vue.prototype.api = api;//请求api
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
Vue.prototype.process = {
  env: process.env
};

Vue.use(Share); //分享组件
Vue.use(Element, { size: 'small' }) //Element
Vue.use(VueLazyload,{ //懒加载
  error:noImg,
  loading:''
});
Vue.use(Viewer);
Vue.use(VueCropper)//图片裁剪插件
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


var isWebKit =  navigator.userAgent.indexOf('WebKit') > -1  // 是否是WebKit 内核 
    console.log('谷歌内核'+ isWebKit)  // 返回 true  则是，false  则不是
/**
 * 监听isRouterAlive，
 * 当被设为false时，
 * 将它设为true，避免异步问题
 */
store.watch(
    // 当返回结果改变...
    (state) => {
      return state.isRouterAlive
    },
    // 执行回调函数
    (newVal,oldValue) => {
      if(!newVal){
        store.dispatch('setIsRouterAlive', true)
      }
    }
)
